module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-ext_latin-700.52bb58c8.woff2";